import { Component, OnInit } from '@angular/core';
import { SubscriptionBaseComponent } from '../../../../../../library/src/lib/core/base-components/subscription/subscription-base.component';
import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';
import { NgDialogService } from '../../../../../../library/src/lib/modules/dialog/services/dialog.service';
import { NgPortfolioService } from '../../../../../../library/src/lib/db/portfolio/portfolio.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'os-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent
  extends SubscriptionBaseComponent
  implements OnInit
{
  isMenuOpen = false;
  isMenuOpen$ = new BehaviorSubject<boolean>(false);

  private isLoading = false;
  constructor(
    private dialogService: NgDialogService,
    private portFolioService: NgPortfolioService
  ) {
    super();
  }



  ngOnInit(): void {
    this.addSubscription(this.initMenuEvent());
    this.addSubscription(this.initIsOpenMenuChange());
  }

  private initMenuEvent(): Subscription {
    return fromEvent(
      document.querySelector('.toolbar-mobile-menu-box'),
      'click'
    ).subscribe((e: Event) => {
      const target: HTMLElement = e.target as HTMLElement;

      if (target.classList.contains('toolbar-child-menu-toggle')) {
        target.parentElement.classList.toggle('active');
      }

      if (target.classList.contains('toolbar-close-link')) {
        this.isMenuOpen$.next(false);
      }
    });
  }

  private initIsOpenMenuChange(): Subscription {
    return this.isMenuOpen$.subscribe((isMenuOpen) => {
      if (isMenuOpen) {
        document.body.classList.add('open__menu');
      } else {
        document.body.classList.remove('open__menu');
      }

      this.isMenuOpen = isMenuOpen;
    });
  }

  openMenu(): void {
    this.isMenuOpen$.next(true);
  }

  openContact(): void {
    this.dialogService.openContact();
  }

  download(): void {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.portFolioService.get('download').subscribe((result) => {
      const { filePath, fileName } = result;

      try {
        fetch(filePath)
          .then((resp) => resp.blob())
          .then((blob) => {
            FileSaver.saveAs(blob, fileName);
          });
      } catch (e) {
        alert('에러가 발생 했습니다. 새로고침 후 다시 시도해주세요.');
      } finally {
        this.isLoading = false;
      }
    });
  }
}
